// extracted by mini-css-extract-plugin
export default {"member-details":"MemberDetails_member-details__A6Pt3","member-data":"MemberDetails_member-data__vb705"};